import { Store, select } from '@ngrx/store';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

//Interfaces
import { IAccidentDetail } from '@accidents/shared/interfaces/accidents';
import { ICustomDropdown } from '@shared/interfaces';

//Constants
import {
  DATA_CLAIMANTS_TABS,
  TAB_ACTION,
  TIPO_DOCUMENTO,
  TIPO_RECLAMO,
  DEPARTAMENTO,
  CATEGORIA_LICENCIA,
  TIPO_PATENTE,
  ESTADO_RECLAMANTES_SAP,
} from '@accidents/shared/constants';

// Reducers
import { ModuleState } from '@app/modules/accidents/store/reducers';

// Actions
import * as EditAccidentActions from '@accidents/store/actions/edit-accident.actions';

// Selectors
import * as DetailAccidentSelectors from '@accidents/store/selectors/detail-accident.selectors';
import * as EditAccidentSelectors from '@accidents/store/selectors/edit-accident.selectors';

@Component({
    selector: 'sbi-cot-back-claimants-data-tab',
    templateUrl: './claimants-data-tab.component.html',
    styleUrls: ['./claimants-data-tab.component.scss'],
    standalone: false
})
export class ClaimantsDataTabComponent implements OnInit {
  public claimantTabs = DATA_CLAIMANTS_TABS;
  public activeClaimantTab = DATA_CLAIMANTS_TABS.PERSONA;
  public tabActionList = TAB_ACTION;
  public claimantsDataForm: FormGroup;
  public personas: any[] = [];
  public animales: any[] = [];
  public cosas: any[] = [];
  public vehiculos: any[] = [];
  public documentTypes: ICustomDropdown[] = [];
  public claimTypes: ICustomDropdown[] = [];
  public licenseDeparmentTypes: ICustomDropdown[] = [];
  public licenseCategoryTypes: ICustomDropdown[] = [];
  public licensePatentTypes: ICustomDropdown[] = [];
  @Input() tabAction: string;
  public accidentDetail: IAccidentDetail;
  public estadoReclamantesSAP = ESTADO_RECLAMANTES_SAP;
  public submitClaimantsSAPFailedOrWaiting: boolean = false;

  // Selectores privados
  private _accidentDetail$ = this._store$.pipe(
    select(DetailAccidentSelectors.selectDetailAccident)
  );

  // Selectores publicos
  public _retrySubmitLoading$ = this._store$.pipe(
    select(EditAccidentSelectors.retrySubmitSAPClaimantsLoading)
  );

  constructor(
    private _formBuilder: FormBuilder,
    private _store$: Store<ModuleState>
  ) {}

  ngOnInit() {
    this._parseDatosAccidente();
    //Config dropdowns
    this._setDocumentTypeDropdownData();
    this._setClaimTypeDropdownData();
    this._setDepartmentDropdownData();
    this._setLicenseTypeDropdownData();
    this._setPatentTypeDropdownData();
  }

  // Private method to set the form data
  private _parseDatosAccidente(): void {
    this._accidentDetail$.subscribe((accidentRequest: IAccidentDetail) => {
      if (accidentRequest) {
        this.accidentDetail = accidentRequest;
        if (this.accidentDetail.reclamantes) {
          this._checkIfReclamanteFallido();
          this._parseClaimers();
        }
      }
    });
  }

  private _parseClaimers(): void {
    if (this.accidentDetail.reclamantes) {
      for (const r of this.accidentDetail.reclamantes) {
        r.activeTab = false;
      }

      this.personas = this.accidentDetail.reclamantes.filter(
        reclamante => reclamante.tipoReclamo == TIPO_RECLAMO.PERSONA
      );
      this.vehiculos = this.accidentDetail.reclamantes.filter(
        reclamante => reclamante.tipoReclamo == TIPO_RECLAMO.VEHICULO
      );
      this.cosas = this.accidentDetail.reclamantes.filter(
        reclamante => reclamante.tipoReclamo == TIPO_RECLAMO.COSA
      );
      this.animales = this.accidentDetail.reclamantes.filter(
        reclamante => reclamante.tipoReclamo == TIPO_RECLAMO.ANIMAL
      );
    }
  }

  //Set if there are failed claimants
  private _checkIfReclamanteFallido(): void {
    this.submitClaimantsSAPFailedOrWaiting =
      !!this.accidentDetail.reclamantes.find(
        reclamante =>
          reclamante.estadoDeProceso == ESTADO_RECLAMANTES_SAP.FALLIDO ||
          reclamante.estadoDeProceso == ESTADO_RECLAMANTES_SAP.EN_ESPERA
      );
  }

  //Set data dropdown tipo documento
  private _setDocumentTypeDropdownData(): void {
    this.documentTypes = TIPO_DOCUMENTO.map(el => ({
      name: el,
      value: el,
    }));
  }

  //Set data dropdown tipo reclamo
  private _setClaimTypeDropdownData(): void {
    this.claimTypes = Object.values(TIPO_RECLAMO).map(el => ({
      name: el,
      value: el,
    }));
  }

  //Set data dropdown departamento
  private _setDepartmentDropdownData(): void {
    this.licenseDeparmentTypes = DEPARTAMENTO.map(el => ({
      name: el,
      value: el,
    }));
  }

  //Set data dropdown categoria licencia
  private _setLicenseTypeDropdownData(): void {
    this.licenseCategoryTypes = CATEGORIA_LICENCIA.map(el => ({
      name: el,
      value: el,
    }));
  }

  //Set data dropdown tipo patente
  private _setPatentTypeDropdownData(): void {
    this.licensePatentTypes = TIPO_PATENTE.map(el => ({
      name: el,
      value: el,
    }));
  }

  public activateTab(obj) {
    obj.activeTab = !obj.activeTab;
  }

  // Public function to retry submiting the claimants to SAP
  public retrySubmitSAPClaimants(): void {
    const listadoReclamantesFallidosId = [];

    this.accidentDetail.reclamantes.map(reclamante => {
      if (
        reclamante.estadoDeProceso == this.estadoReclamantesSAP.FALLIDO ||
        reclamante.estadoDeProceso == this.estadoReclamantesSAP.EN_ESPERA
      )
        listadoReclamantesFallidosId.push(reclamante.id);
    });

    this._store$.dispatch(
      EditAccidentActions.retrySubmitSAPClaimantsRequested({
        payload: {
          claimantsIdList: listadoReclamantesFallidosId,
          accidentId: this.accidentDetail.id,
        },
      })
    );
  }
}
